const helpPages = {
  home: 'https://help.anchor.fm/hc/:locale',
  newRequest: 'https://help.anchor.fm/hc/:locale/requests/new',
  troubleshooting: 'https://help.anchor.fm/hc/:locale/articles/360041864132',
  distributingYourPodcast:
    'https://help.anchor.fm/hc/:locale/articles/360030793032',
  monetizingYourPodcastSection:
    'https://help.anchor.fm/hc/:locale/sections/360001911411',
  monetizingEpisodesWithSongs:
    'https://help.anchor.fm/hc/:locale/articles/360045619992',
  creatorBetaProgramRules:
    'https://help.anchor.fm/hc/:locale/articles/360058061032',
  consumerBetaProgramRules:
    'https://help.anchor.fm/hc/:locale/articles/360058514391',
  whatIsAnRSSfeed: 'https://help.anchor.fm/hc/:locale/articles/4402979021723',
  privateRSS: 'https://help.anchor.fm/hc/:locale/articles/4408823441435',
  subscriptionFAQs: 'https://help.anchor.fm/hc/:locale/articles/4408650289819',
  sponsorshipsCPM: 'https://help.anchor.fm/hc/:locale/articles/360018693552',
  cashingOutFromYourWallet:
    'https://help.anchor.fm/hc/:locale/articles/360012563112',
  podcastListenerSupport:
    'https://help.anchor.fm/hc/:locale/articles/360007452031',
  communityGuidelines:
    'https://help.anchor.fm/hc/:locale/articles/360012584591',
  voiceMessages: 'https://help.anchor.fm/hc/:locale/articles/360001018972',
  switchingToAnchor: 'https://help.anchor.fm/hc/:locale/articles/360023100411',
  redirectingFromAudioboom:
    'https://help.anchor.fm/hc/:locale/articles/360033800652',
  redirectingFromBluebrry:
    'https://help.anchor.fm/hc/:locale/articles/360023104171',
  redirectingFromBuzzsprout:
    'https://help.anchor.fm/hc/:locale/articles/360022857032',
  redirectingFromCastbox:
    'https://help.anchor.fm/hc/:locale/articles/360043395971',
  redirectingFromFeedburner: 'https://anch.co/Redirecting-From-Feedburner',
  redirectingFromIVoox:
    'https://help.anchor.fm/hc/:locale/articles/360042980552',
  redirectingFromLibsyn:
    'https://help.anchor.fm/hc/:locale/articles/360023502772',
  redirectingFromMegaphone:
    'https://help.anchor.fm/hc/:locale/articles/360024875252',
  redirectingFromPodbean:
    'https://help.anchor.fm/hc/:locale/articles/360027282052',
  redirectingFromPodomatic:
    'https://help.anchor.fm/hc/:locale/articles/360033800752',
  redirectingFromSimpleCast:
    'https://help.anchor.fm/hc/:locale/articles/360036878091',
  redirectingFromSoundCloud:
    'https://help.anchor.fm/hc/:locale/articles/360025173471',
  redirectingFromSpreaker:
    'https://help.anchor.fm/hc/:locale/articles/360024883312',
  redirectingFromSquarespace:
    'https://help.anchor.fm/hc/:locale/articles/360033061792',
  redirectingFromTransistor:
    'https://help.anchor.fm/hc/:locale/articles/360024880672',
  paidSubsConsumerInternationalTerms:
    'https://help.anchor.fm/hc/:locale/articles/4410661427739',
  paidSubsConsumerGermanyTerms:
    'https://help.anchor.fm/hc/:locale/articles/4410661468955',
  paidSubsConsumerDomesticTerms:
    'https://help.anchor.fm/hc/:locale/articles/360058514391-Podcast-Subscriptions-Consumer-Terms',
};

export const paths = {
  anchor: {
    home: '/',
    features: '/features',
    switch: '/switch',
    switchForm: '/switch/form',
    ads: '/ads',
    login: '/login',
    signup: '/signup',
    network: '/dashboard/network',
    dashboard: '/dashboard',
    episodes: '/dashboard/episodes',
    money: '/dashboard/money',
    settings: '/dashboard/podcast/edit',
    notFound: '/404',
  },
  legal: {
    tos: '/tos',
    privacy: '/privacy',
    dmca: '/dmca',
    ccpa: '/ccpa',
  },
  stripe: {
    privacy: 'https://stripe.com/privacy',
    ssa: 'https://stripe.com/ssa',
  },
  getHelpPage: (helpPage: keyof typeof helpPages, locale?: string) =>
    helpPages[helpPage].replace(':locale', locale || 'en-us'),
  blog: {
    home: 'https://blog.anchor.fm',
    music: 'https://blog.anchor.fm/music',
    coverartDosAndDonts: 'https://blog.anchor.fm/create/dos-donts-coverart',
    freePodcastingWithAnchor:
      'https://blog.anchor.fm/updates/why-podcasting-is-free-with-anchor',
    paidSubscriptions: 'https://blog.anchor.fm/paid-subscriptions',
    growAudience: 'https://blog.anchor.fm/share/grow-audience',
  },
  medium: {
    growYourPodcast:
      'https://medium.com/anchor/how-to-grow-your-podcast-part-1-8e2e320a8643',
  },
  spotify: {
    advertiserTOS:
      'https://www.spotify.com/brands/legal/advertiser-terms-and-conditions/',
    jobs: {
      creationPlatform: 'https://spotifyjobs.com/jobs?q=Creation%20Platform',
    },
  },
};
